export const iconKontrak = "https://img.icons8.com/?size=100&id=119056&format=png&color=000000";
export const iconPerusahaan = "https://img.icons8.com/?size=100&id=lrrWa22VGVi6&format=png&color=000000";
export const iconNilaiKontrak = "https://img.icons8.com/?size=100&id=KyaxbI6JuwGT&format=png&color=000000";
export const iconTanggalKontrak = "https://img.icons8.com/?size=100&id=PTVr218c3sJO&format=png&color=000000";

